import React, { useState, useEffect } from 'react';

function Tiles() {
    const [tilesData, setTilesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch data from the API
        const fetchTilesData = async () => {
            try {
                const response = await fetch('/api/tiles'); // Replace with your API endpoint
                if (!response.ok) {
                    throw new Error('Failed to fetch tiles data');
                }
                const data = await response.json();
                setTilesData(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTilesData();
    }, []); // Empty dependency array ensures this runs once on mount

    if (loading) {
        return <p>Loading tiles...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div className="row row-cols-1 row-cols-md-1 row-cols-lg-3 g-4">
            {tilesData.map((tile, index) => (
                <div className="col" key={index}>
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">{tile.title}</h5>
                            <p className="card-text">{tile.description}</p>
                            <a href={tile.link} className="btn btn-primary">
                                Learn More
                            </a>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Tiles;